<template>
  <div class="autocomplete row">
    <b-form-group
      :class="inputClass"
      :label="inputLabel"
      :label-for="inputId"
      class="col-md-12 mb-0">
      <div>
        <b-form-input
          :id="inputId"
          v-model="searchInput"
          :disabled="disabled"
          :placeholder="placeholder"
          :required="required"
          autocomplete="off"
          type="text"
          @input="onChange();"
          @keydown.down="onArrowDown"
          @keydown.up="onArrowUp"
          @keydown.enter="onEnter"
        />
        <ul v-show="isOpen" id="autocomplete-elements" class="autocomplete-elements">
          <li v-for="(element, i) in elements" :key="i" :class="{ 'is-active': i === arrowCounter }"
              class="autocomplete-element d-flex justify-content-between" @click=setElement(element) :title="showDocumentExpired(element)">
            <span>{{ element.toString }}</span>
            <file-alert-icon  v-if="element && element.hasOwnProperty('nbHistoryDocuments') && element.nbHistoryDocuments>0" size="20px" class="invalid-document"></file-alert-icon>
          </li>
        </ul>
      </div>
    </b-form-group>
  </div>
</template>

<script>

export default {
  name: 'AutoCompleteObjectField',

  props: {
    items: {
      type: Array,
      required: false,
      default: () => []
    },
    selectedElement: {
      type: Object,
      required: false,
      default: null
    },
    inputId: {
      type: String,
      required: true
    },
    inputLabel: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      required: false,
      default: ''
    },
    inputClass: {
      type: String,
      required: true
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data() {
    return {
      lastElement: {toString:''},
      isOpen: false,
      elements: [],
      arrowCounter: -1,
      searchInput: ''
    };
  },

  watch: {
    items: function (value, oldValue) {
      if (value.length !== oldValue.length) {
        this.elements = value;
      }
    }
  },

  mounted() {
    document.addEventListener('click', this.handleClickOutside);
    document.getElementById(this.inputId).addEventListener('blur', this.handleClickOutside);
    if(this.selectedElement) {
      this.setElement(this.selectedElement)
    }
  },

  destroyed() {
    document.removeEventListener('click', this.handleClickOutside);
    document.getElementById(this.inputId).removeEventListener('blur', this.handleClickOutside);
  },

  methods: {
    setElement(element) {
      this.searchInput = element.toString
      this.isOpen = false
      this.emitChangeSelectedValue(element)
    },

    filterElements() {
      this.elements = this.items.filter((item) => {
        return item.toString.toLowerCase().indexOf(this.searchInput.toLowerCase()) > -1;
      });
    },

    onChange() {
      this.$emit('input', this.searchInput);
      this.filterElements()
      this.isOpen = true
      if(this.lastElement.toString !== this.searchInput) {
        this.emitChangeSelectedValue({toString:this.searchInput})
      }
    },

    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.isOpen = false
        this.arrowCounter = -1
        if(this.lastElement.toString !== this.searchInput) {
          this.emitChangeSelectedValue({toString:this.searchInput})
        }
      }
    },

    showDocumentExpired(element){
      let str = ""
      if(element && element.hasOwnProperty('nbHistoryDocuments') && element.nbHistoryDocuments>0){
        str = " Document(s) expiré(s) : \n"
        element.historyDocuments.forEach((document)=>{
          str += document.name + '\n'
        })
      }
      return str
    },

    onArrowDown() {
      if (this.arrowCounter < this.elements.length) {
        this.arrowCounter = this.arrowCounter + 1;
      }
    },
    onArrowUp() {
      if (this.arrowCounter > 0) {
        this.arrowCounter = this.arrowCounter - 1;
      }
    },
    onEnter() {
      let element = {toString:this.searchInput}
      if (this.arrowCounter !== -1) {
        this.searchInput = this.elements[this.arrowCounter];
        element = this.elements[this.arrowCounter]
      } else {
        this.items.push(this.searchInput)
      }
      this.isOpen = false;
      this.arrowCounter = -1;
      this.emitChangeSelectedValue(element)
    },

    emitChangeSelectedValue(element) {
      this.lastElement.toString = element.toString
      this.$emit('elementValueChanged', element);
    }
  }
};

</script>

<style>
.autocomplete {
  position: relative;
}

.autocomplete-elements {
  padding: 0;
  margin: 0;
  border: 1px solid #eeeeee;
  background: var(--main-white);
  position: fixed;
  z-index: 3;
  width: 20%;
}

.autocomplete-element {
  list-style: none;
  text-align: left;
  padding: 4px 10px;
  cursor: pointer;
}

.autocomplete-element.is-active,
.autocomplete-element:hover {
  background-color: var(--main-color);
  color: white;
  padding: 10px;
}

.invalid-document{
  color: var(--main-red);
}
</style>



// WEBPACK FOOTER //
// src/components/b122/editFields/AutoCompleteObjectField.vue